import { connect, ConnectedComponent } from "react-redux";

import * as StoreTypes from "../../../DataTypes/storeTypes";
import * as ConfirmationActions from "../../../Actions/confirmationActions";
import * as StripeTypes from "../../../../Common/Stripe/types";
import { CreditCardForm } from "../../../../Common/Stripe/CreditCardForm";
import { selectIsStripeConnected } from "../../../Helpers/selectors";

const mapStateToProps = (state: StoreTypes.IStore, ownProps: StripeTypes.IProps): StripeTypes.IProps => {
    const info = state.stepsInfo[state.common.currentStep] as StoreTypes.IConfirmationStepInfo;
    const serviceInfo = state.stepsInfo[StoreTypes.Step.Service] as StoreTypes.IServiceStepInfo;
    const organisationInfo = state.initialSettings.accountInitialSettings.organisationInfo;

    const amountFee = serviceInfo.amountFee;
    const totalAmountFee = serviceInfo.totalAmountFee;
    const fee = serviceInfo.isPortalDeposit && !selectIsStripeConnected(state) ? totalAmountFee : amountFee;

    return {
        ...ownProps,
        showEditable: !info.cardInfo || info.isEditCreditCard,
        cardInfo: info.cardInfo,
        cdnHost: state.initialSettings.cdnHost,
        isLoggedIn: !!state.initialSettings.loggedInClientId,
        cardFee: {
            enabled: state.initialSettings.stripeFeeEnabled,
            fee: fee,
            currencySymbol: organisationInfo.currencySymbol,
        },
    };
};

const mapDispatchToProps = (dispatch, ownProps: StripeTypes.IProps): StripeTypes.IProps => {
    return {
        ...ownProps,
        editCreditCard: () => {
            dispatch(ConfirmationActions.editCreditCard(true));
        },
        onDataChanged: () => {
            dispatch(ConfirmationActions.setIdempotencyKeyAction(null));
        },
        onWillUnmount: () => {
            dispatch(ConfirmationActions.setIdempotencyKeyAction(null));
        },
    };
};

export const CreditCardFormConnected: ConnectedComponent<typeof CreditCardForm, any> = connect(
    mapStateToProps,
    mapDispatchToProps
)(CreditCardForm);
